import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import * as JsBarcode from 'jsbarcode';
import jsPDF from 'jspdf';
import { forkJoin } from 'rxjs';
import { GeneralService } from 'src/app/services/general.service';
import QRCode from 'qrcode';
@Component({
  selector: 'app-suivi-code-barre',
  templateUrl: './suivi-code-barre.component.html',
  styleUrls: ['./suivi-code-barre.component.scss'],
})
export class SuiviCodeBarreComponent implements OnInit {
  api = this.generalService.api;
  userSites = [];
  imageToShow: any;
  listCodes = [];
  sourceFlag = true;
  destinationFlag = true;
  ref;
  reference;
  suiviFormGroup: FormGroup;
  colis_DS: any = {};
  depart = null;
  arrive = null;
  imgCodeList = [];
  printingType;
  quantityCodesToPrint = 1;
  disableBtn = false;
  showAlertFail = false;
  showAlertTimeOut;
  availableSitesDepart: Array<string> = [];
  availableSitesArriver: Array<string> = [];
  validRef = true;
  constructor(
    private generalService: GeneralService,
    private fb: FormBuilder
  ) {
    //! you must route between dashbord and suivi code to show print  
    // test bar code
    // this.depart = "chihia"
    // this.arrive = "Bizerte"
    //  this.arrive = "bouzayen home"
    // this.arrive = "Bureau en ligne Home"
    // this.listCodes.push('137779')
    // this.generateBarCode('137779', 0);
    // this.generateBarCode('137779.1', 0);
    // setTimeout(() => {
    //   this.print('bar');
    // }, 1000);
  }

  ngOnInit(): void {
    this.getColis_DS();
    this.buildSuiviFormGroup();
    this.generalService.rechercheTable2('SitesColisA').subscribe((res: any) => {
      this.availableSitesArriver = res.map((e) => e.Site_Code);
    });
    this.generalService.rechercheTable2('SitesColisD').subscribe((res: any) => {
      this.availableSitesDepart = res.map((e) => e.Site_Code);
    });


  }

  buildSuiviFormGroup() {
    this.suiviFormGroup = this.fb.group({
      Colis_Code: this.fb.control(null),
      Colis_DepartType: this.fb.control(null),
      Colis_Depart: this.fb.control(null),
      Colis_ArriveType: this.fb.control(null),
      Colis_Arrive: this.fb.control(null),
      Colis_Ref: this.fb.control(null),
      Colis_Texte: this.fb.control(null),
      U_timestamp: this.fb.control(null),
      Colis_DateDepart: this.fb.control(null),
      Colis_DateArrive: this.fb.control(null),
      User_Id_Create: this.fb.control(null),
      Date_Create: this.fb.control(null),
      User_Id_Modif: this.fb.control(null),
      Date_Modif: this.fb.control(null),
      destinationFlag: this.fb.control(null),
      sourceFlag: this.fb.control(null),
    });
  }

  print(type): void {
    let printContents =
      '<div style="    display: flex;flex-direction: column;position: absolute;top: 0;left: 0;padding-left:5px">';
    this.imgCodeList.forEach((img, index) => {
      const h = index == this.imgCodeList.length - 1 ? 2.5 : 3;
      if (type != 'bar') {
        printContents += `<div style="text-align: center;
        display: grid;
        justify-content: center;
        position: relative;
        font-size: 15px;
        margin: 0;
        align-items: center;
        height: ${h}cm;
        width: 4cm;">
      <img src='${img.img}' style="    height: 90px;
      margin: 0;
      position: absolute;
      top: 10px; 
      left: 35px;" />

      <div style='    top: 90px;
      position: absolute;
      width: 90%;
      display: flex;
      justify-content: space-between;
      padding-left: 9px;
      padding-right: 8px;
      font-size: 12px;
      left: 0;
      '><span>${img.code}</span><span>${this.arrive}</span></div>
      </div>`;
      } else {
        console.log(index);

        if (index == 0) {
          console.log(1);
          
          
          printContents += `<div style="text-align: center;
        display: flex;
        justify-content: center;
        position: relative;
        font-size: 15px;
        margin: 0;
        align-items: center;
        height: ${h}cm;
        width: 4cm;">
      <img src='${img.img}' style="width: 100%;
      margin: 0;
      position: absolute;
      top: 8px;
      left: 0;"/>

      <div style='top: 75px;
      position: absolute;
      width: 90%;
      display: flex;
      justify-content: space-between;
      padding-left: 9px;
      padding-right: 8px;
      font-size: 12px;
      left: 0;
      '><span>${this.depart}</span><span>${img.code}</span><span>${this.arrive}</span></div>
      </div>`;
        }
        else {
          console.log(2);
          printContents += `<div style="text-align: center;
        display: flex;
        justify-content: center;
        position: relative;
        font-size: 15px;
        margin: 0;
        align-items: center;
        height: ${h}cm;
        width: 4cm;">
      <img src='${img.img}' style="width: 100%;
      margin: 0;
      position: absolute;
      top: 8px;
      left: 0;"/>

      <div style='top: 58px;
      position: absolute;
      width: 90%;
      display: flex;
      justify-content: space-between;
      padding-left: 9px;
      padding-right: 8px;
      font-size: 12px;
      left: 0;
      '><span>${this.depart}</span><span>${img.code}</span><span>${this.arrive}</span></div>
      </div>`;
        }

      }
    });
    printContents += '</div>';

    let popupWin;
    popupWin = window.open('_blank', '_blank', 'top=0,left=0,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
    <body  onload="window.print();window.close()" style="margin-top:0px">${printContents}</body>
      </html>`);
    popupWin.document.close();
    this.arrive = '';
    this.quantityCodesToPrint = 1;
    this.depart = '';
    this.imgCodeList = [];
    this.listCodes = [];
    this.disableBtn = false;
    this.buildSuiviFormGroup();
  }












  externeToggle = false
  LastTimeCliked = 0
  async save(type) {
    // this.listCodes.push('666666');
    // this.generateBarCode('666666.99', 0);
    // setTimeout(() => {
    //   this.print('bar');
    // }, 1000);
    // return;
    console.log(Date.now() - this.LastTimeCliked);

    if (Date.now() - this.LastTimeCliked > 1500) {
      this.LastTimeCliked = Date.now();
      if (this.disableBtn) return;
      this.disableBtn = true;
      this.printingType = type;
      Object.assign(this.colis_DS.Colis[0], this.suiviFormGroup.value);

      // convert boolean to number
      this.colis_DS.Colis[0].Colis_DepartType = Number(
        this.colis_DS.Colis[0].sourceFlag
      );
      this.colis_DS.Colis[0].Colis_ArriveType = Number(
        this.colis_DS.Colis[0].destinationFlag
      );

      // hard coded
      this.colis_DS.Colis[0].Colis_Code = '1';

      // delete the view model properties from the ds
      delete this.colis_DS.Colis[0].destinationFlag;
      delete this.colis_DS.Colis[0].sourceFlag;
      // ? logic Modification
      // ? we send request for just one code
      if (!this.externeToggle) {
        if (this.availableSitesDepart.indexOf(this.depart) != -1 && this.availableSitesArriver.indexOf(this.arrive) != -1) {
          this.enregistrer(type)
          this.generalService.dialogSuccess(
            'Enregistrement Avec Succés',
            true
          );
        }
        else
          this.generalService.dialogSuccess(
            'Veuillez vérifiez les données',
            false
          );
      }
      else {
        if (this.availableSitesDepart.indexOf(this.depart) != -1) {
          this.enregistrer(type)
          this.generalService.dialogSuccess(
            'Enregistrement Avec Succés',
            true
          );
        }
        else
          this.generalService.dialogSuccess(
            'Veuillez vérifiez les données',
            false
          );
      }
      this.disableBtn = false;
    }

  }
  enregistrer(type) {
    this.generalService.enregisterTable(this.colis_DS).subscribe(
      async (r) => {
        // const r = { code: '1000' }; // ! HARD CODED

        this.listCodes.push(r.code); // ? we got the first code. EX : 1000 of index 0

        if (this.quantityCodesToPrint <= 1) {
          // * if we only have one code
          // * w generate the Barcode / Qrcode
          if (type == 'qr') {
            this.generateQrCode(r.code, 0);
          } else if (type == 'bar') {
            this.generateBarCode(r.code, 0);
          }
          // * only one code
          setTimeout(() => {
            this.print(type);
          }, 1000);
          return;
        }

        // ? now we repeat quantityCodesToPrint ( > 1) times
        // ! we start from  1 so already got the element 0
        let codes = []; // * For API request
        for (let index = 1; index < this.quantityCodesToPrint; index++) {
          // ? we contcat the first code with a '.n' where n is the index of the code
          codes.push({
            ...this.colis_DS.Colis[0],
            Colis_Code: r.code + '.' + index,
          });
          this.listCodes.push(r.code + '.' + index); // ? EXP : listCodes => [100,100.1,100.2]
        }

        this.generalService.getDS('Colis2').subscribe((ds: any) => {
          ds.Colis = codes; // * new font-end made codes

          this.generalService.enregisterTable(ds).subscribe(() => {
            // ? every thing is saved we can print now !
            this.listCodes.forEach((code, index) => {
              if (type == 'qr') {

                this.generateQrCode(code, index);
              } else if (type == 'bar') {
                this.generateBarCode(code, index);
              }
            });
            setTimeout(() => {
              this.externeToggle = false
              //!add it To eanable buuton
              // this.disableBtn = false;
              this.print(type);
            }, 1000);
          });
        });
      },
      (err) => {
        this.disableBtn = false;
        this.showAlertFail = true;
        setTimeout(() => {
          this.showAlertFail = false;
        }, 7000);

        return;
      }
    );
  }

  getColis_DS() {
    this.generalService.getDS('Colis').subscribe((ds) => {
      this.colis_DS = ds;
    });
  }
  generateQrCode(code, i) {
    var opts = {
      errorCorrectionLevel: 'H',
      type: 'image/jpeg',
      quality: 0.5,
      margin: 1,
      color: {
        dark: '#000',
        light: '#FFF',
      },
    };

    QRCode.toDataURL(code, opts, (err, url) => {
      if (err) throw err;
      let loop = setInterval(() => {
        if (document.getElementById('imgCode' + i)) {
          var img: any = document.getElementById('imgCode' + i);
          img.src = url;
          this.imgCodeList.push({
            img: img.src,
            type: 'qr',
            code: code,
          });
          clearInterval(loop);
        }
      }, 100);
    });
  }
  generateBarCode(code, index) {
    let loop = setInterval(() => {
      // ? the html img can get some ms to load in the DOM
      if (document.getElementById('imgCode' + index)) {
        let barCodeImg: any = document.getElementById('imgCode' + index);
        JsBarcode('#imgCode' + index, code, {
          height: 56,
          displayValue: false,
        });
        this.imgCodeList.push({
          img: barCodeImg.src,
          type: 'bar',
          code: code,
        });
        clearInterval(loop);
      }
      console.log(this.imgCodeList);

    }, 100);
  }
  isValid(state, site) {
    if (state == 'Depart') return this.availableSitesDepart.indexOf(site) != -1;
    return this.availableSitesArriver.indexOf(site) != -1;
  }
  clearArriveCode() {
    this.arrive = null;
  }
  checkValidRef() {
    if (!this.reference || this.reference == '') this.validRef = true;
    else
      this.generalService
        .rechercheTable('apiColiVerif', this.depart + ',' + this.reference)
        .subscribe((res) => {
          this.validRef = res.length == 0;
          console.log(res.length);
        });
  }
}
